import axios from 'axios'
import { getByIdProductsUrl, getProductsByCategoryUrl } from '../../../common/xhr/gateway'

export const GET_PRODUCTS = 'GET_PRODUCTS'
export const SET_PRODUCTS = 'SET_PRODUCTS'
export const CLEAR_PRODUCTS = 'CLEAR_PRODUCTS'

export const onLoadProducts = ({ format, lang, category = {}, productId, dispatchProducts, userId }) => {
  dispatchProducts({
    type: GET_PRODUCTS,
    category,
    productId
  })

  const url = category.id
    ? getProductsByCategoryUrl({ category: category.id, lang, format, viewSize: 10, userId })
    : getByIdProductsUrl({ lang, format, productCodes: [productId], userId })

  return axios.get(url).then(resp => {
    dispatchProducts({
      type: SET_PRODUCTS,
      products: resp.data.products,
      category
    })
    return resp
  })
}

export const clearProductsState =
  ({ dispatchProducts }) =>
  () => {
    dispatchProducts({
      type: CLEAR_PRODUCTS
    })
  }
